import ReactGA from 'react-ga';

// Check if GA has been initialized before initializing
if (!window.GA_INITIALIZED) {
  ReactGA.initialize('G-0YQ4J2FH9R');
  window.GA_INITIALIZED = true;
}

// You may choose to export other tracking functions or configurations if needed
